import * as React from 'react';
import * as styles from './Banner.css';
import { Section } from '../Section';

interface IBannerProps {
  backgroundColor: string;
  backgroundImage: string;
  color: string;
  onClick?(): void;
  title: string;
}

const BannerComponent: React.FC<IBannerProps> = ({ backgroundColor, backgroundImage, color, onClick, title }) => {
  return (
    <Section>
      <div
        className={styles['container']}
        onClick={onClick}
        style={{ backgroundColor, color }}
        role="button"
        tabIndex={0}
        data-testid="Banner"
      >
        <div className={styles['content']}>
          <h2 className={styles['title']} role="presentation">
            {title}
          </h2>
        </div>
        <div className={styles['image']} style={{ backgroundImage: `url(${backgroundImage})` }} />
      </div>
    </Section>
  );
};

export const Banner = React.memo(BannerComponent);
